import { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import './index.scss'

import AppHeader from '../../components/Header'
import AppFooter from '../../components/Footer'

import PRODUCTCONFIG from '../../configs/product'

class Product extends Component {

  state = {
    activeIndex: 0
  }

  componentDidMount () {
    document.getElementById('root').scrollTop = 0

    let { type = 0 } = this.props.location.state || {}
    this.setState({ activeIndex: type })
  }

  handleChangeMenu (index) {
    this.setState({ activeIndex: index })
  }

  transImage (array) {
    for (let index = 0; index < array.length; index++) {
      const element = array[index]
      if (element.type === 'image') return element.src
    }
    return ''
  }

  render () {
    let { lang } = this.props
    let { activeIndex } = this.state
    let { title, info } = PRODUCTCONFIG
    return (
      <div className='app-page page-product'>
        <AppHeader />
        <div className='page-container'>
          <div className='product-title'>{title[lang]}</div>
          <div className='product-tab flex-justify'>
            {
              info.map((item, index) => {
                return (
                  <div className={`tab-item ${index === activeIndex ? 'active' : ''}`} key={index} onClick={this.handleChangeMenu.bind(this, index)}>
                    <div className='item-text'>{item.title[lang]}</div>
                  </div>
                )
              })
            }
          </div>
          <div className='flex-justify'>
            <div className='max-width flex-justify'>
              <div className='product-list'>
                {
                  info[activeIndex].content.map((item, index) => {
                    return (
                      <div className='list-block' key={index}>
                        <div className='block-image box'>
                          <div className='box-content'>
                            <div className='image-content background-image' style={{ backgroundImage: `url(${this.transImage(item.images)})` }}></div>
                          </div>
                        </div>
                        <div className='block-title one-line-ellipsis'>{item.name[lang]}</div>
                        <div className='block-introduction'>
                          {
                            item.introduction.slice(0, 5).map((_item, idx) => {
                              return (
                                <div className='introduction-item one-line-ellipsis' key={idx}>{_item[lang]}</div>
                              )
                            })
                          }
                          {item.introduction.length > 5 && <div className='introduction-item'>{lang === 'cn' ? '更多' : 'More'}...</div>}
                        </div>
                        <div className='flex flex-justify-end'>
                          <Link className='block-view flex-align-justify' to={{ pathname: '/product/detail', state: { type: activeIndex, id: index } }}>查看详情介绍</Link>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
        <AppFooter />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    lang: state.app.lang
  }
}

export default connect(mapStateToProps)(Product)
